export const Hamburger = {
  el: document.querySelector('.js-hamburger'),

  init: function () {
    if (this.el) {
      this.el.addEventListener('click', () => {
        document.body.classList.toggle('menu_open')
      })
    }
  }
}

export const MobileMenu = {
  menuItems: document.querySelectorAll('.js-nav-item'),
  instances: [],
  activeSubmenu: null,
  clickedSubmenuIndex: null,

  areElementsStyled: false,

  onClick: function (e) {
    e.preventDefault()

    this.clickedSubmenuIndex = this.instances.findIndex(_ => _.link.el.isEqualNode(e.target))
    this.openSubmenu(this.clickedSubmenuIndex)
  },

  openSubmenu: function () {
    const i = this.clickedSubmenuIndex
    let translate = 0
    this.instances.forEach((_, j) => {
      if (i !== this.activeSubmenu) {
        if (j === i + 1) {
          translate += this.instances[i].submenu.height
        }
        if (i === j && _.submenu.el) {
          _.submenu.el.setAttribute('style', 'transform:scaleY(1);')
        } else if (_.submenu.el) {
          _.submenu.el.setAttribute('style', 'transform:scaleY(0);')
        }
      } else if (_.submenu.el) {
        _.submenu.el.setAttribute('style', 'transform:scaleY(0);')
      }
      _.menuItem.setAttribute('style', `transform: translateY(${translate}px);`)
    })

    if (i === this.activeSubmenu) {
      this.activeSubmenu = null
    } else {
      this.activeSubmenu = i
    }
  },

  initInstances: function () {
    this.instances.forEach((_, i) => {
      if (_.submenu.el)
        _.link.el.addEventListener('click', this.onClick)
    })
  },

  init: function () {
    this.onClick = this.onClick.bind(this)

    if (window.matchMedia('(max-width:767px)').matches) {
      if (this.menuItems.length) {
        this.menuItems.forEach(menuItem => {
          const link = menuItem.querySelector('.js-nav-link')
          const linkHeight = link ? parseInt(getComputedStyle(link).lineHeight.replace('px', '')) : 0
          const submenu = menuItem.querySelector('.js-submenu')
          const submenuItems = submenu ? submenu.querySelectorAll('li > a') : []
          const submenuItemHeight = submenuItems.length ? parseInt(getComputedStyle(submenuItems[0]).lineHeight.replace('px', '')) : 0
          const submenuHeight = submenuItemHeight * submenuItems.length
  
          this.instances.push({
            menuItem,
            link: {
              el: link,
              height: linkHeight
            },
            submenu: {
              el: submenu,
              height: submenuHeight
            },
            submenuItems: {
              els: submenuItems,
              lineHeight: submenuItemHeight
            }
          })
        })
        this.initInstances()
        this.areElementsStyled = true
      }
    }
  },

  resize: function () {
    if (window.matchMedia('(max-width:767px)').matches) {
      if (this.instances.length) {
        this.instances.forEach(_ => {
          _.link.height = _.link.el ? parseInt(getComputedStyle(_.link.el).lineHeight.replace('px', '')) : 0
          _.submenuItems.lineHeight = _.submenuItems.els.length ? parseInt(getComputedStyle(_.submenuItems.els[0]).lineHeight.replace('px', '')) : 0
          _.submenu.height = _.submenuItems.lineHeight * _.submenuItems.els.length
        })
        this.areElementsStyled = true
      } else {
        if (this.menuItems.length) {
          this.menuItems.forEach(menuItem => {
            const link = menuItem.querySelector('.js-nav-link')
            const linkHeight = link ? parseInt(getComputedStyle(link).lineHeight.replace('px', '')) : 0
            const submenu = menuItem.querySelector('.js-submenu')
            const submenuItems = submenu ? submenu.querySelectorAll('li > a') : []
            const submenuItemHeight = submenuItems.length ? parseInt(getComputedStyle(submenuItems[0]).lineHeight.replace('px', '')) : 0
            const submenuHeight = submenuItemHeight * submenuItems.length
    
            this.instances.push({
              menuItem,
              link: {
                el: link,
                height: linkHeight
              },
              submenu: {
                el: submenu,
                height: submenuHeight
              },
              submenuItems: {
                els: submenuItems,
                lineHeight: submenuItemHeight
              }
            })
          })
          this.initInstances()
          this.areElementsStyled = true
        }
      }
    } else {
      if (this.instances.length) {
        if (this.areElementsStyled) {
          this.instances.forEach(_ => {
            _.submenu.el.removeAttribute('style')
            _.menuItem.removeAttribute('style')
            _.link.el.removeEventListener('click', this.onClick)
          })
          this.areElementsStyled = false
        }
      }
    }
  }
}

export const DashboardSidebarToggle = {
  open: document.querySelector('.js-dashboard-sidebar-open'),
  close: document.querySelector('.js-dashboard-sidebar-close'),
  sidebar: document.querySelector('.js-dashboard-sidebar'),

  onTouchMove: function (e) {
    e.preventDefault()
  },

  preventTouchEvent: function (e) {
    e.stopPropagation()
  },

  init: function () {
    if (this.sidebar) {
      this.onTouchMove = this.onTouchMove.bind(this)
      this.preventTouchEvent = this.preventTouchEvent.bind(this)

      if (this.open) {
        this.open.addEventListener('click', () => {
          document.body.classList.add('dashboard-sidebar_open')
          window.addEventListener('touchmove', this.onTouchMove)
          this.sidebar.addEventListener('touchmove', this.preventTouchEvent)
        })
      }
      if (this.close) {
        this.close.addEventListener('click', () => {
          document.body.classList.remove('dashboard-sidebar_open')
          window.removeEventListener('touchmove', this.onTouchMove)
          this.sidebar.removeEventListener('touchmove', this.preventTouchEvent)
        })
      }
    }
  }
}


// WEBPACK FOOTER //
// app/javascript/scripts/components/Navigation.js